/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculators & Finance`)
};

const es_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras y finanzas`)
};

const de_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner & Finanzen`)
};

const nl_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekenmachines & Financiën`)
};

const fr_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrices et finance`)
};

const it_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori & Finanza`)
};

const pt_br2_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras e Finanças`)
};

const pt_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras e Finanças`)
};

const ja_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算機・金融`)
};

const zh_cat_calculators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算器与财务`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_calculators_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_calculators_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_calculators_name", locale)
	if (locale === "en") return en_cat_calculators_name(inputs)
	if (locale === "es") return es_cat_calculators_name(inputs)
	if (locale === "de") return de_cat_calculators_name(inputs)
	if (locale === "nl") return nl_cat_calculators_name(inputs)
	if (locale === "fr") return fr_cat_calculators_name(inputs)
	if (locale === "it") return it_cat_calculators_name(inputs)
	if (locale === "pt-BR") return pt_br2_cat_calculators_name(inputs)
	if (locale === "pt") return pt_cat_calculators_name(inputs)
	if (locale === "ja") return ja_cat_calculators_name(inputs)
	return zh_cat_calculators_name(inputs)
};